import * as _ from 'lodash';
import { Optional } from 'utility-types';

import { BudgetTemplateLineEntity } from '../types/models/budget-template';

export enum Frequency {
  Daily = 'daily',
  Weekly = 'weekly',
  BiWeekly = 'bi-weekly',
  SemiMonthly = 'semi-monthly',
  Monthly = 'monthly',
  BiMonthly = 'bi-monthly',
  Quarterly = 'quarterly',
  SemiAnnually = 'semi-annually',
  Annually = 'annually',
}

export const FrequencyPerYear = {
  [Frequency.Daily]: 365,
  [Frequency.Weekly]: 52,
  [Frequency.BiWeekly]: 26,
  [Frequency.SemiMonthly]: 24,
  [Frequency.Monthly]: 12,
  [Frequency.BiMonthly]: 6,
  [Frequency.Quarterly]: 4,
  [Frequency.SemiAnnually]: 2,
  [Frequency.Annually]: 1,
};

export const FrequencyLabels = {
  [Frequency.Daily]: 'Daily',
  [Frequency.Weekly]: 'Weekly',
  [Frequency.BiWeekly]: 'Every two weeks',
  [Frequency.SemiMonthly]: 'Twice a month',
  [Frequency.Monthly]: 'Monthly',
  [Frequency.BiMonthly]: 'Every two months',
  [Frequency.Quarterly]: 'Quarterly',
  [Frequency.SemiAnnually]: 'Twice a year',
  [Frequency.Annually]: 'Annually',
};

export type BudgetTemplateLine = Optional<BudgetTemplateLineEntity, 'id'>;

export const FrequencySelectOptions = _.values(Frequency).map(value => {
  return [value, FrequencyLabels[value]] as [string, string];
});
